export default __webpack_public_path__ + "static/media/flower.6e749821.png";